var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"loader",style:({height: ("" + _vm.height), width: ("" + _vm.width), 'border-top': (_vm.thickness + " solid " + _vm.color)})})}
var staticRenderFns = []

export { render, staticRenderFns }